import React from 'react'
import Button from './Button'
import enhancer from './enhancers'
import PropTypes from 'prop-types'

function LinkButton({ href, ...props }) {
  return <Button href={href} {...props} link />
}

LinkButton.propTypes = {
  href: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.object.isRequired,
  ]).isRequired,
}

export default enhancer(LinkButton)
